import client from '../httpClient';

const getUserCsvDownloadApi = (params) => {
  const responseType = 'arraybuffer';
  return client.get('/division-masters/user-csv-download', { params, responseType });
};

export default getUserCsvDownloadApi;
